<template>
    <console-content max-width="1280px">
        <v-row class="mt-5" justify="center" align="center">
            <v-col cols="auto" class="pt-0 pb-0 headline text-start">담당자 목록</v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pt-0 pb-0">
                <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>

        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mx-auto">
                <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>
                <v-card-text>
                    <v-row class="mt-6">
                        <v-col cols="12" sm="6" md="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys"
                                item-text="text" item-value="value" clearable hide-details label="검색조건" placeholder=":: 전체 ::" @input="filter.searchValue = null"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" :disabled="!filter.searchKey" clearable hide-details label="검색어" placeholder=" "/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="search">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>

        <v-data-table :headers="workersHeaders" :items="workers" disable-sort disable-pagination hide-default-footer :items-per-page="-1" class="mt-4 elevation-1">
            <template v-slot:[`body`]="{ items, headers }">
                <draggable v-model="workers" tag="tbody" @input="update">
                    <tr v-for="item, i in items" :key="i">
                        <td v-for="header, j in headers" :key="j" class="text-center">
                            <template v-if="header.value == 'phone'">
                                <span v-if="item.phone">{{ item.phone.phoneNumberFormat() }}</span>
                                <span v-else>-</span>
                            </template>
                            <template v-else-if="header.value == 'createdAt'">
                                <span v-if="item.createdAt">{{ item.createdAt.toDateTime() }}</span>
                                <span v-else>-</span>
                            </template>
                            <template v-else-if="header.value == 'scope'">
                                <span v-if="item.scope">{{ getLevelText(item.scope) }}</span>
                                <span v-else>-</span>
                            </template>
                            <template v-else-if="header.value == 'actions'">
                                <v-icon small class="mx-1" @click="edit(item)"> mdi-pencil </v-icon>
                                <v-icon small class="mx-1" @click="remove(item)"> mdi-delete </v-icon>
                            </template>
                            <template v-else>
                                {{ item[header.value] }}
                            </template>
                        </td>
                    </tr>
                </draggable>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500">
            <template v-slot:[`activator`]>
                <v-btn bottom color="accent" dark fab fixed right @click="create()">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>

            <v-card v-if="worker">
                <v-card-title>
                    <span class="subtitle-2">{{ workerIndex > -1 ? "담당자 수정" : "담당자 등록" }}</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="worker.name" label="담당자 이름" placeholder=" " hide-details />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="worker.phone" label="연락처" placeholder=" " hide-details @input="value => worker.phone = String(value).replace(/[^0-9]/g, '')" />
                        </v-col>
                        <v-col cols="12">
                            <v-select v-model="worker.scope" multiple label="등급" :items="levels" hide-details/>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="grey" class="ml-auto" @click="cancel()">취소</v-btn>
                    <v-btn text color="primary" class="ml-2" @click="save()">확인</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </console-content>
</template>

<script>
import ConsoleContent from "@/components/console/console-content.vue";
import Draggable from "vuedraggable";

import api from "@/api";

import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent,
        Draggable
    },
    props: {
        viewType: String,
    },
    data() {
        return {
            mdiMicrosoftExcel, // 엑셀아이콘

            showSearch: true,
            levels: [],

            filter: {
                searchKey: null,
                searchValue: null,
            },

            workers: [],
            workersHeaders: [{
                    text: "담당자 이름",
                    align: "center",
                    width: 200,
                    value: "name",
                },
                {
                    text: "연락처",
                    align: "center",
                    width: 128,
                    value: "phone",
                },
                {
                    text: "권한",
                    align: "center",
                    width: 128,
                    value: "scope",
                },
                {
                    text: "등록일자",
                    align: "center",
                    width: 160,
                    value: "createdAt",
                },
                {
                    text: "Actions",
                    value: "actions",
                    width: 100,
                    align: "center",
                },
            ],

            worker: null,
            dialog: false,

            searchKeys: [
                { text: "담당자 이름", value: "name" },
                { text: "연락처", value: "phone" }
            ]
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.search();
            this.getLevels();
        },
        async search(){
            let { me } = await api.console.me.get();
            this.workers = me.workers.filter(worker => this.filter.searchKey && this.filter.searchValue ? worker[this.filter.searchKey].indexOf(this.filter.searchValue) > -1 : true );
        },
        async getLevels() {
            try {
                let { levels } = await api.console.levels.getLevels();
                this.levels = levels.map((level) => ({ text: level.name, value: level.code}));
                if(this.hasConsoleScope) this.levels = [{text:"최고관리자", value: "console"}, ...this.levels];
            } catch(error){
                console.error(error);
            }
        },
        create(){
            this.worker = { name: null, phone: null };
            this.workerIndex = -1;
            this.dialog = true;
        },

        edit(worker) {
            this.worker = { ...worker };
            this.workerIndex = this.workers.indexOf(worker);
            this.dialog = true;
        },

        cancel(){
            this.dialog = false;
        },

        async save(){
            (this.workerIndex > -1) ? this.workers[this.workerIndex] = this.worker : this.workers.push(this.worker);

            await api.console.me.put({
                workers: this.workers
            });

            await this.search();

            this.dialog = false;
        },

        async update(){
            await api.console.me.put({
                workers: this.workers
            });

            await this.search();
        },

        async remove(worker){
            if(confirm("삭제하시겠습니까?")){
                this.workers.splice(this.workers.indexOf(worker), 1);
    
                await api.console.me.put({
                    workers: this.workers
                });
    
                await this.search();
            }
        },

        getLevelText(scope) {
            return scope.map((el) => [{text:"최고관리자", value: "console"},...this.levels].find((level) => level?.value === el)).map((el)=> el.text).join(", ");
        }

    },
    computed: {
        hasConsoleScope(){
            return this.$store.state.payload.scope.includes("console");
        }
    }
};
</script>
